export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 30,
  },
  title: {
    fontSize: 24,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: 'black',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 20,
    width: '80%',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 20,
    marginBottom: 20,
    width: '100%',
  },
  icon: {
    alignSelf: 'center',
  },
}
